export function isBundledMobileApp(): boolean {
  return import.meta.env.VITE_MOBILE_BUNDLED === 'true';
}

/** APK bundled com entry SPA (Vue Router), sem shell Inertia. */
export function isBundledSpaMode(): boolean {
  return isBundledMobileApp();
}

export function mobileApiBaseUrl(): string {
  const base = import.meta.env.VITE_API_BASE_URL || '';

  return base.replace(/\/$/, '');
}

export function resolveMobileApiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;

  return `${mobileApiBaseUrl()}${normalized}`;
}
